export default {
  loadingFailed: 'Failed to load the clinic. Please try again.',
};
